
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { BookingItemProps } from ".";
import { loading, create } from "store/booking";

interface ApiBookingCreateInputProps extends Omit<BookingItemProps, "id"> {
}

type ApiBookingCreateOutputProps = OutputBaseProps<{ item: BookingItemProps; }, ApiBookingCreateInputProps>;

export const apiBookingCreate = async (data: ApiBookingCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiBookingCreateOutputProps>("/api/booking/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
    }
    return res;
};